
  <div class="content">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <div class="push"></div>
  </div>
  <app-footer *ngIf="displayFooter" class="footer"></app-footer>
  <app-loader></app-loader>
    